import { client } from "../../../../utils";

export const getActionsForRoleRequest = () => client.get("auth-policy-definitions");

export const getRolesRequest = () => client.get("roles");

export const getRolesAllRequest = () => client.get("roles-all");

export const createRoleRequest = (data) => client.post("roles", data);

export const updateRoleRequest = ({ id, data }) => client.put(`role/${id}`, data);

export const deleteRoleRequest = (id) => client.delete(`role/${id}`);

export const getRoleRoleByIDRequest = (id) => client.get(`role/${id}`);
